/**
 * @param keys - массив ключей
 */
const reformatCPKeys = (keys: string[]) => {
    const BUY_index = keys.findIndex(it => it === 'BUY')
    const SELL_index = keys.findIndex(it => it === 'SELL')
    const HEDGING_index = keys.findIndex(it => it === 'HEDGING')
    const result = keys.map((item, index) => {
        if (index > BUY_index && index < SELL_index) {
            return item + " (BUY)"
        } else if (index > SELL_index && index < HEDGING_index) {
            return item + " (SELL)"
        } else if (index > HEDGING_index) {
            return item + " (HEDGING)"
        } else return item
    })
    return result;
}

export default reformatCPKeys
